import React from "react";
import { Col } from "react-bootstrap";

/**
 * Reusable radio button group component
 */
const RadioGroup = ({
  // Field props
  name,
  selectedValue,
  onChange,
  options = [],
  label,
  required = false,

  // Validation props
  error,
  errorMessage,

  // Layout props
  colProps = {},
  className = "mb-3 d-flex radio-buttons",

  // Other props
  ...otherProps
}) => {
  return (
    <Col {...colProps}>
      {label && (
        <div className="radio-buttons">
          <label className="radio-label">
            {label} {required && "*"}
          </label>
        </div>
      )}
      <div className={className}>
        {options.map((option, index) => (
          <div
            key={index}
            className={`radio ${index < options.length - 1 ? "mr-4" : ""}`}
          >
            <input
              id={`${name}-${option.value}`}
              value={option.value}
              name={name}
              type="radio"
              checked={selectedValue === option.value}
              onChange={onChange}
              {...otherProps}
            />
            <label htmlFor={`${name}-${option.value}`} className="radio-label">
              {option.label}
            </label>
            {option.sublabel && (
              <>
                <br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <label style={{ fontSize: 12 }}>{option.sublabel}</label>
              </>
            )}
          </div>
        ))}
      </div>
      {error && <p style={{ color: "red" }}>{errorMessage}</p>}
    </Col>
  );
};

export default RadioGroup;
